import { memo } from 'react';

interface TaskBoxIndicatorsProps {
  riskLevel: "high" | "medium" | "low" | null;
  totalRisk?: number;
  isMultitasking: boolean;
}

export const TaskBoxIndicators = memo(function TaskBoxIndicators({
  riskLevel,
  totalRisk,
  isMultitasking,
}: TaskBoxIndicatorsProps) {
  if (!riskLevel && !isMultitasking) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 3, flexShrink: 0 }}>
      {riskLevel && (
        <span
          style={{
            fontSize: 9,
            padding: '1px 4px',
            borderRadius: 3,
            backgroundColor:
              riskLevel === 'high'
                ? '#ef4444'
                : riskLevel === 'medium'
                ? '#eab308'
                : '#22c55e',
          }}
        >
          σ{totalRisk?.toFixed(1)}
        </span>
      )}
      {isMultitasking && (
        <span
          style={{
            fontSize: 9,
            backgroundColor: '#f97316',
            padding: '1px 4px',
            borderRadius: 3,
          }}
        >
          MT
        </span>
      )}
    </div>
  );
});
